import { Button, Card, Col, Row, Collapse, Form, Container, Spinner } from "react-bootstrap";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet'
import { BsPlusLg } from "react-icons/bs";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RiFilter3Line } from "react-icons/ri";
import Multiselect from 'multiselect-react-dropdown';
import dayjs from "dayjs";
import ModalPermessi from "../../Utilities/ModalPermessi";
import { FaRegCalendarAlt } from "react-icons/fa";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { statiProgetto } from "../../Utilities/statiElementEnum";
import { getStatusOrderProgetto } from "../../Utilities/getStatusOrder";
import CartaProgetto from "./CartaProgetto";
import PaginationBasic from "../Homepage/Pagination"


// Funzione helper per leggere in sicurezza da sessionStorage
const getInitialState = (key, defaultValue) => {
    const storedValue = sessionStorage.getItem(key);
    if (storedValue === null) {
        return defaultValue;
    }
    try {
        const parsed = JSON.parse(storedValue);
        return parsed !== null ? parsed : defaultValue;
    } catch (e) {
        console.warn(`Errore nel parsing del sessionStorage [${key}]:`, e);
        return defaultValue;
    }
};


export default function EsploraProgetti(props) {

    /* mappa */
    const zoom = 12;
    const ResizeMap = () => {
        const map = useMap();
        map._onResize();
        return null;
    };
    //gestione mappa

    const navigate = useNavigate();

    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const [disableButton, setDisableButton] = useState(false);
    const [mostraModalPermessi, setMostraModalPermessi] = useState(false);
    const [titolo, setTitolo] = useState("");
    const [messaggio, setMessaggio] = useState("");
    const [mode, setMode] = useState("");

    let [listaProgetti, setListaProgetti] = useState([]);


    /* STATI PER LA PAGINAZIONE */
    const [paginaNumero, setPaginaNumero] = useState(0)
    const elementiPerPagina = 5
    const paginaVisitata = paginaNumero * elementiPerPagina
    /* ************************ */

    // filtri

    const [dateRange, setDateRange] = useState(() =>
        getInitialState('filtriProgetti_dateRange', [null, null])
    );
    let [categoriaFilter, setCategoriaFilter] = useState(() =>
        getInitialState('filtriProgetti_categoriaFilter', [])
    );
    const [selectedOptions, setSelectedOptions] = useState(() =>
        getInitialState('filtriProgetti_selectedOptions', [])
    );
    const [areaSelezionata, setAreaSelezionata] = useState(() =>
        getInitialState('filtriProgetti_areaSelezionata', -1)
    );

    // --- Hooks per salvare i filtri in sessionStorage ad ogni modifica ---
    useEffect(() => {
        sessionStorage.setItem('filtriProgetti_dateRange', JSON.stringify(dateRange));
    }, [dateRange]);

    useEffect(() => {
        sessionStorage.setItem('filtriProgetti_categoriaFilter', JSON.stringify(categoriaFilter));
    }, [categoriaFilter]);

    useEffect(() => {
        sessionStorage.setItem('filtriProgetti_selectedOptions', JSON.stringify(selectedOptions));
    }, [selectedOptions]);

    useEffect(() => {
        sessionStorage.setItem('filtriProgetti_areaSelezionata', JSON.stringify(areaSelezionata));
    }, [areaSelezionata]);
    const areeUrbanePresenti = (props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcAreeUrbane && props.comune.impostazioniComune.imcAreeUrbane.aree_urbane) || ["Caricamento..."]

    useEffect(() => {
        //console.log("cambiate props Esploara progetti")
        //console.log("iniziative in EsploraProgetti", props.iniziativa.progetti)
        let opt = props.comune.impostazioniComune && props.comune.impostazioniComune.imcCategorieProgetti.categorie_progetti;
        opt = [...opt, ...listaProgetti.flatMap((p) => p.progCategorie?.categorie)];
        let categoriePresenti = [...new Set(opt)].sort().map((el, index) => ({ name: el, id: index }));
        setOptions(categoriePresenti);

        if (props.iniziativa.progetti && props.iniziativa.progetti.length > 0) {
            setListaProgetti(props.iniziativa.progetti);
        }
        if (props.iniziativa.fasiIniziativa) {
            let faseCorrente = props.iniziativa.fasiIniziativa.filter((fase) =>
                dayjs().isBetween(fase.finiDataInizio, fase.finiDataFine, null, [])
            )[0];
            setDisableButton(faseCorrente ? !faseCorrente.finiFlInvioProgetti : true);
        }

    }, [props]);

    const pulisciFiltri = () => {
        setDateRange([null, null]);
        setSelectedOptions([]);
        setCategoriaFilter([]);
        setAreaSelezionata(-1);
        setPaginaNumero(0); // Resetto alla prima pagina

        // Aggiungi la pulizia del sessionStorage
        sessionStorage.removeItem('filtriProgetti_dateRange');
        sessionStorage.removeItem('filtriProgetti_categoriaFilter');
        sessionStorage.removeItem('filtriProgetti_selectedOptions');
        sessionStorage.removeItem('filtriProgetti_areaSelezionata');
    };

    const handleDateRangeChange = (update) => {
        if (update === null) {
            setDateRange([null, null]);
        } else {
            setDateRange(update);
        }
        setPaginaNumero(0); // Resetto alla prima pagina

    };

    const handleAreaSelezionata = (value) => {
        setAreaSelezionata(value)
        setPaginaNumero(0); // Resetto alla prima pagina

    }

    const getProgetti = () => {
        let ret = listaProgetti;

        ret = ret.filter(progetto => progetto.progStato !== statiProgetto.InValidazione && progetto.progStato !== statiProgetto.Rifiutato)


        if (categoriaFilter.length > 0) {
            ret = ret.filter((prog) => prog.progCategorie.categorie.some((cat) => categoriaFilter.includes(cat)));
        }

        if (dateRange[0]) {
            let startDay = dayjs(dateRange[0]);
            ret = ret.filter((prog) =>
                dayjs(prog.progDataPubblicazione).isAfter(startDay) || dayjs(prog.progDataPubblicazione).isSame(startDay)
            );
        }

        if (dateRange[1]) {
            let endDay = dayjs(dateRange[1]);
            ret = ret.filter((prog) =>
                dayjs(prog.progDataPubblicazione).isBefore(endDay) || dayjs(prog.progDataPubblicazione).isSame(endDay)
            );
        }

        if (areaSelezionata != -1) {
            console.log("areaSelezionata != -1", areaSelezionata)
            console.log("areaSelezionata != -1", ret.map((prog) => prog))

            ret = ret.filter((prog) => prog.progArea === areaSelezionata);
        }

        return ret;
    };
    const listaPosizioni = getProgetti().map(prog => prog.posizione)


    const handleSelect = (_, selectedItem) => {
        setCategoriaFilter((old) => [...old, selectedItem.name]);
        setSelectedOptions((old) => [...old, selectedItem]);
        setPaginaNumero(0); // Resetto alla prima pagina

    };

    const handleRemove = (_, removedItem) => {
        setSelectedOptions((old) => old.filter((el) => el.id !== removedItem.id));
        setCategoriaFilter(categoriaFilter.filter((el) => el !== removedItem.name));
        setPaginaNumero(0); // Resetto alla prima pagina

    };

    const IsLogged = () => {
        if (props.partecipante && props.partecipante.parId) {
            if (props.partecipante.ruolo && props.partecipante.ruolo.ruoFlVisualizzatore && props.partecipante.ruolo.ruoFlPubblicatoreProgetti) {
                navigate('/crea-progetto', { state: { iniziativa: props.iniziativa?.iniId } });
            } else {
                setTitolo("Attenzione: operazione illecita");
                setMessaggio("Attualmente non possiedi i permessi per creare una proposta. L'operazione è bloccata!");
                setMode("danger");
            }
        } else {
            setTitolo("Attenzione");
            setMessaggio("Per procedere con la creazione di una nuova proposta devi prima effettuare il login!");
            setMode("warning");
        }
        setMostraModalPermessi(true);
    };

    return (
        <>
            <Card style={{ minHeight: "100vh", borderTop: "none", borderRadius: "0px" }}>
                <Card.Body className="p-0 m-0 pb-4">
                    <Row className="d-md-none w-100 p-0 m-0">
                        <Col xs={12} sm={6} className="p-1">
                            <Button className="w-100 mb-2" disabled={disableButton} onClick={IsLogged}>
                                Crea il tuo progetto
                                <BsPlusLg className="ms-2" />
                            </Button>
                        </Col>
                        {
                            props.comune.comId === 2 && props.comune.comTitoloUfficiale === "Modena" && [602, 202, 302].includes(props.iniziativa.iniId) ?
                                (
                                    <>

                                    </>
                                ) : (
                                    <>
                                        <Col xs={12} sm={6} className="p-1">
                                            <Button className="w-100" onClick={() => setOpen(!open)}>
                                                <RiFilter3Line className="me-2" />
                                                Mostra filtri
                                            </Button>
                                        </Col>
                                        <Collapse in={open} className="border-bottom pb-3">
                                            <div>
                                                <FilterForm
                                                    options={options}
                                                    selectedOptions={selectedOptions}
                                                    handleSelect={handleSelect}
                                                    handleRemove={handleRemove}
                                                    dateRange={dateRange}
                                                    handleDateRangeChange={handleDateRangeChange}
                                                    pulisciFiltri={pulisciFiltri}
                                                    areaSelezionata={areaSelezionata}
                                                    handleAreaSelezionata={handleAreaSelezionata}
                                                    areeUrbanePresenti={areeUrbanePresenti}
                                                    comune={props.comune}
                                                    iniId={props.iniziativa.iniId}
                                                />
                                            </div>
                                        </Collapse>
                                    </>
                                )
                        }

                    </Row>
                    <Row className="w-100 m-0 p-0" style={{ minHeight: "100vh" }}>
                        <Col md={3} className="bg-light d-none d-md-block">
                            <div className="d-flex justify-content-center">
                                <Button className="my-3" disabled={disableButton} onClick={IsLogged}>
                                    Crea il tuo progetto
                                    <BsPlusLg className="ms-2" />
                                </Button>
                            </div>
                            {
                                props.comune.comId === 2 && props.comune.comTitoloUfficiale === "Modena" && [602, 202, 302].includes(props.iniziativa.iniId) ?
                                    (
                                        <>
                                        </>)
                                    : (<>
                                        <FilterForm
                                            options={options}
                                            selectedOptions={selectedOptions}
                                            handleSelect={handleSelect}
                                            handleRemove={handleRemove}
                                            dateRange={dateRange}
                                            handleDateRangeChange={handleDateRangeChange}
                                            pulisciFiltri={pulisciFiltri}
                                            areaSelezionata={areaSelezionata}
                                            handleAreaSelezionata={handleAreaSelezionata}
                                            areeUrbanePresenti={areeUrbanePresenti}
                                            comune={props.comune}
                                            iniId={props.iniziativa.iniId}
                                        /></>)
                            }
                        </Col>
                        {/* TUTTI I PROGETTI */}
                        <Col md={9} xs>
                            {props.loadingIni ?
                                <Container className="text-center mt-5">
                                    <Spinner animation="border" role="status" />
                                </Container>
                                :
                                <>
                                    {/* MAPPA */}
                                    {
                                        props.comune.comId === 2 && props.comune.comTitoloUfficiale === "Modena" && [602, 202, 302].includes(props.iniziativa.iniId) ? (
                                            <>

                                            </>
                                        ) : (<>
                                            <MapContainer className="mx-1 mt-1" style={{ height: "30vh" }}
                                                center={props.comune.impostazioniComune && props.comune.impostazioniComune.imcCentroMappa.centro_mappa}
                                                zoom={zoom} scrollWheelZoom={false}>
                                                <ResizeMap />
                                                <TileLayer
                                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                />
                                                {listaPosizioni.length > 0 &&
                                                    listaPosizioni.map((posizione, index) => (
                                                        <Marker
                                                            position={[posizione.posLatitudine, posizione.posLongitudine]}
                                                            key={index}
                                                        >
                                                            <Popup minWidth={90}>
                                                                <span>
                                                                    {posizione.posNome}
                                                                </span>
                                                            </Popup>
                                                        </Marker>
                                                    ))}
                                            </MapContainer>
                                        </>)

                                    }



                                    {getProgetti().length > 0 && (
                                        <>
                                            {
                                                getProgetti()
                                                    .sort(function (a, b) {
                                                        return getStatusOrderProgetto(a.progStato) - getStatusOrderProgetto(b.progStato)
                                                    })
                                                    .slice(paginaNumero * elementiPerPagina, (paginaNumero + 1) * elementiPerPagina)
                                                    .map((progetto, index) => (
                                                        <CartaProgetto key={index}
                                                            progetto={progetto}
                                                            iniziativa={props.iniziativa}
                                                            partecipante={props.partecipante}
                                                            comune={props.comune} />
                                                    ))
                                            }

                                            < PaginationBasic
                                                activepage={paginaNumero}
                                                setActivePage={setPaginaNumero}
                                                numItems={getProgetti().length}
                                                itemsPerPage={elementiPerPagina}
                                            />
                                        </>)
                                    }</>}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <ModalPermessi
                mostra={mostraModalPermessi}
                setMostra={setMostraModalPermessi}
                titolo={titolo}
                messaggio={messaggio}
                mode={mode}
            />
        </>
    );
}

const FilterForm = ({ options, selectedOptions, handleSelect, handleRemove, dateRange, handleDateRangeChange, pulisciFiltri,
    areaSelezionata, handleAreaSelezionata, areeUrbanePresenti, comune
}) => (
    <>
        <h4 className="mt-4">Filtra per:</h4>
        <div className="divider my-4" />
        <Row>
            <Col>
                <p>Categorie</p>
                <Multiselect
                    options={options}
                    selectedValues={selectedOptions}
                    onSelect={handleSelect}
                    onRemove={handleRemove}
                    displayValue="name"
                />
            </Col>
        </Row>
        <div className="divider my-4" />
        <Row>
            <Col>
                <p>Area Urbana</p>
                <Form.Select
                    size="sm"
                    className="mb-4"
                    value={areaSelezionata}
                    style={{ color: areaSelezionata == -1 ? '#6c757d' : 'inherit' }}
                    onChange={(ev) => { handleAreaSelezionata(ev.target.value) }}
                >
                    <option value="-1" style={{ color: '#6c757d' }} >Seleziona l'area urbana</option>
                    {areeUrbanePresenti.map((el, index) => (
                        <option value={el} key={index}>{el}</option>
                    ))}
                </Form.Select>
            </Col>
        </Row>
        <>
            {
                // comune di modena senza il filtro per la data pubblicazione
                comune.comId == 2 && comune.comTitoloUfficiale == "Modena" ?
                    <>
                    </>
                    :
                    <>
                        <div className="divider my-4" />
                        <Row>
                            <Col>
                                <p>Data pubblicazione &nbsp;
                                    <span className="small text-muted">(Da ... a)</span>
                                </p>
                                <DateRangePicker
                                    className="w-100"
                                    id="datePickerPetizioni"
                                    onChange={handleDateRangeChange}
                                    value={dateRange}
                                    returnValue="range"
                                    calendarIcon={<FaRegCalendarAlt style={{ height: '1em', width: '1em' }} />}
                                    dayPlaceholder="gg"
                                    monthPlaceholder="mm"
                                    yearPlaceholder="aaaa"
                                    format="dd/MM/y"
                                />
                            </Col>
                        </Row>
                    </>
            }

            <div className="d-flex justify-content-center mt-4">
                <Button size="sm" variant="outline-primary" onClick={pulisciFiltri}>
                    Pulisci filtri di ricerca
                </Button>
            </div>
        </>
    </>
);
